module.exports = {
  apiConfig: {
    localhost: "http://10.196.85.147",
    port:"8817",
    devApi: "http://10.196.85.188:60041", //  开发环境 - 正式
    // devApi: "http://10.196.85.188:60041", //  开发环境 - wang
    // devApi: "http://10.196.85.45:60041", //  开发环境 - jiang
    proApi: "https://app1.guinsoft.com", // 生产环境
    fileServer: "http://10.196.85.109", // 后台ip
    deductionMoney:10000,   //可使用优惠券的最小订单金额
  },

}



// WEBPACK FOOTER //
// ./src/config/apiConfig.js